// extracted by mini-css-extract-plugin
export default {"container":"Addresses_container__pPEyf","wrapper":"Addresses_wrapper__6Cb2X","addNew":"Addresses_addNew__-f-PS"};